import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectCoverflow,
  Autoplay,
} from "swiper";

import i1 from "../../../../../assets/images/reviewcarousel/1.webp";
import i2 from "../../../../../assets/images/reviewcarousel/2.webp";
import i3 from "../../../../../assets/images/reviewcarousel/3.webp";
import i4 from "../../../../../assets/images/reviewcarousel/4.webp";
import i5 from "../../../../../assets/images/reviewcarousel/5.webp";
import i6 from "../../../../../assets/images/reviewcarousel/6.webp";
import i7 from "../../../../../assets/images/reviewcarousel/7.webp";
import i8 from "../../../../../assets/images/reviewcarousel/8.webp";
import i9 from "../../../../../assets/images/reviewcarousel/9.webp";
import i10 from "../../../../../assets/images/reviewcarousel/10.webp";
import i11 from "../../../../../assets/images/reviewcarousel/11.webp";
import i12 from "../../../../../assets/images/reviewcarousel/12.webp";
import i13 from "../../../../../assets/images/reviewcarousel/13.png";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

import "../../../../../sass/files/reviewslider.scss";

export default function ReviewCarousel() {
  const reviews = [
    i1,
    i2,
    i3,
    i4,
    i5,
    i6,
    i7,
    i8,
    i9,
    i10,
    i11,
    i12,
    i13,
  ];

  return (
    <Swiper
      effect={"coverflow"}
      grabCursor={true}
      centeredSlides={true}
      slidesPerView={"auto"}
      loop={reviews.length > 2}
      speed={900}
      autoplay={{
        delay: 2200,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      }}
      coverflowEffect={{
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1,
        scale: 0.9,
        slideShadows: false,
      }}
      breakpoints={{
        0: {
          spaceBetween: 8,
        },
        481: {
          spaceBetween: 10,
        },
        769: {
          spaceBetween: 14,
        },
        1025: {
          spaceBetween: 18,
        },
      }}
      className="mySwiper"
      navigation={true}
      pagination={{ clickable: true }}
      scrollbar={false}
      modules={[
        EffectCoverflow,
        Navigation,
        Pagination,
        Scrollbar,
        A11y,
        Autoplay,
      ]}
    >
      {reviews.map((img, index) => (
        <SwiperSlide key={index}>
          <img src={img} alt={`Review ${index + 1}`} className="h-full" />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}